import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div<IsMobile>`
  margin-top: 7rem;
  display: flex;
  justify-content: center;
  gap: 8rem;
  min-height: calc(100vh - 6rem);

  ${({ isMobile }) => isMobile && css`
    margin-top: 3rem;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 33rem;

  > button {
    margin-top: 3rem;
    width: 100%;
    border-radius: 50px;
    font-size: 14px;
  }
`